

module.exports = __webpack_require__.stylable.create(
    "Sidebar1299384805",
    {"classes":{"root":"Sidebar1299384805__root"},"vars":{},"stVars":{},"keyframes":{}},
    "",
    1,
    "Sidebar1299384805",
    null
);
